import { AxiosPromise } from 'axios';
import { apiService } from '@app/services';

class DarkwebService {
    readonly apiBase: string = '/api/integrations';

    getIntegrations(handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.get(`${this.apiBase}`, { onError: handleError, onSuccess: handleSuccess, local: true }).catch();
    }

    getReports(orgId: string, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.get(`${this.apiBase}/darkweb/reports/${orgId}`, { onError: handleError, onSuccess: handleSuccess, local: true }).catch();
    }

    enableScanning(vaultId: number, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService
            .put(`${this.apiBase}/darkweb/vault/${vaultId}`, {}, { onError: handleError, onSuccess: handleSuccess, local: true })
            .catch();
    }

    getFeaturesStatus(orgId: string, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.get(`${this.apiBase}/darkweb/features/`, {params: {orgId: orgId}, onError: handleError, onSuccess: handleSuccess, local: true}).catch();
    }

    getCompromisedUsers(reportId: string, skip: number, take: number, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService
            .get(`${this.apiBase}/darkweb/reports/${reportId}/compromised-users`, {
                params: {
                    take: take,
                    skip: skip
                },
                onError: handleError,
                onSuccess: handleSuccess,
                local: true
            })
            .catch();
    }

    updateCompromisedUserStatus(id: string, status: string, handleError?: Function, handleSuccess?: Function): AxiosPromise {
        return apiService
            .put(
                `${this.apiBase}/darkweb/reports/compromised-users/${id}`,
                { status: status },
                { onError: handleError, onSuccess: handleSuccess, local: true }
            )
            .catch();
    }

    blockCompromised(organizationId: string, isActive: boolean, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService
            .put(
                `${this.apiBase}/darkweb/features/${organizationId}/vault-password`,
                { isActive: isActive },
                { onError: handleError, onSuccess: handleSuccess, local: true }
            )
            .catch();
    }

    changeCsvState(organizationId: string, isActive: boolean, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService
            .put(
                `${this.apiBase}/darkweb/features/${organizationId}/csv-import`,
                { isActive: isActive },
                { onError: handleError, onSuccess: handleSuccess, local: true }
            )
            .catch();
    }
    scheduleCompromisesReportForOrg(orgId: string, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService
            .post(
                `${this.apiBase}/darkweb/reports/${orgId}/compromised-users`, {},
                {
                    onError: handleError,
                    onSuccess: handleSuccess,
                    local: true
                }
            )
            .catch();
    }
}

export const darkwebService = new DarkwebService();
